import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'es',
  messages: {}
})

export async function loadMessages(locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const messages = await import(
            /* webpackChunkName: '' */ `../lang/${ locale }`
    )
    i18n.setLocaleMessage(locale, messages)
  }
}

(async function () {
      loadMessages('es')
  })()
  
export default i18n